var map = {
	"./Achievement.js": "./resources/2.0/js/models/Achievement.js",
	"./App.js": "./resources/2.0/js/models/App.js",
	"./Audience.js": "./resources/2.0/js/models/Audience.js",
	"./AudienceAttribute.js": "./resources/2.0/js/models/AudienceAttribute.js",
	"./Base.js": "./resources/2.0/js/models/Base.js",
	"./Comment.js": "./resources/2.0/js/models/Comment.js",
	"./Connection.js": "./resources/2.0/js/models/Connection.js",
	"./DiscussionCategory.js": "./resources/2.0/js/models/DiscussionCategory.js",
	"./File.js": "./resources/2.0/js/models/File.js",
	"./FilePlaylist.js": "./resources/2.0/js/models/FilePlaylist.js",
	"./Folder.js": "./resources/2.0/js/models/Folder.js",
	"./FolderPlaylist.js": "./resources/2.0/js/models/FolderPlaylist.js",
	"./Hub.js": "./resources/2.0/js/models/Hub.js",
	"./Page.js": "./resources/2.0/js/models/Page.js",
	"./Playlist.js": "./resources/2.0/js/models/Playlist.js",
	"./PlaylistHub.js": "./resources/2.0/js/models/PlaylistHub.js",
	"./Prompt.js": "./resources/2.0/js/models/Prompt.js",
	"./Section.js": "./resources/2.0/js/models/Section.js",
	"./Segment.js": "./resources/2.0/js/models/Segment.js",
	"./Sitemap.js": "./resources/2.0/js/models/Sitemap.js",
	"./Tag.js": "./resources/2.0/js/models/Tag.js",
	"./Template.js": "./resources/2.0/js/models/Template.js",
	"./Transcription.js": "./resources/2.0/js/models/Transcription.js",
	"./Webhook.js": "./resources/2.0/js/models/Webhook.js",
	"./Widget.js": "./resources/2.0/js/models/Widget.js",
	"./WisdomQuery.js": "./resources/2.0/js/models/WisdomQuery.js",
	"./WisdomSession.js": "./resources/2.0/js/models/WisdomSession.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/2.0/js/models sync ^\\.\\/.*\\.js$";